jQuery(($) => {

  const $modalOverlay = $('.js-modal-overlay')

  $('.slider__carousel').owlCarousel({
      items:1,
      nav:false,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4000,
      autoplaySpeed: 800
  })

  $('.bestsellers__carousel').owlCarousel({
    items: 4,
    loop: true
  })

  $('.customers__carousel').owlCarousel({
    items: 5,
    loop: true
  })

  $modalOverlay.on('click', function() {
    $('.js-menu-content').removeClass('is-visible')
    $('.js-button-header').removeClass('is-active')
    $modalOverlay.removeClass('is-visible')
  })

  $('.js-button-header').on('click', function(event) {
    event.preventDefault()

    const panelId = $(this).attr('href')
    const $currentPanel = $(panelId)

    if($currentPanel.hasClass('is-visible')) {
      $currentPanel.removeClass('is-visible')
      $(this).removeClass('is-active')
      $modalOverlay.removeClass('is-visible')
      return
    }

    $('.js-button-header').removeClass('is-active')
    $(this).addClass('is-active')
    $modalOverlay.addClass('is-visible')

    $('.js-menu-content').removeClass('is-visible')
    $currentPanel.addClass('is-visible')

    $("#s").focus();

  })

  /* Designer */
  $('div.fpd-container').on('modalDesignerOpen', function(event) {
    console.log("entra");
    $('<div class="fpd-logo"><img class="header__logo-image" src="/wp-content/themes/kendoo/img/logo-kendoo@2x.png" alt="Kendoo" /></div>').insertBefore('div.fpd-done.fpd-btn');
  });

  $(window).on('scroll', function() {

    if(!$('body').hasClass('home')) {
      return
    }

    const top = $(window).scrollTop()
    const $header = $('.js-header')

    if(top > 100) {
      $header.addClass('is-scrolled')
    } else {
      $header.removeClass('is-scrolled')
    }
  })

  jQuery(function() {
    console.log("kendoo up and running!");
    const $header = $('.js-header')
    if (window.location.pathname != '/') {
      $header.addClass('is-scrolled');
    }
  });

  let categoryInSubmenu = null

  $('.header__navigation, section.slider, #menu-primary-menu').on('mouseover', function(event) {
    const target = $(this).attr("class").split(/\s+/).find(c => c.includes('target-'));
    if(!target && $('.js-sub-nav.is-shown').length > 0) {
      $('.js-sub-item').removeClass('is-active');
      $('.js-sub-menu-item').hide();
      $('.js-sub-nav').removeClass('is-shown');
      categoryInSubmenu = null;
    }
  });

  $(('section.sub-nav')).on('mouseover', function(event) {
    event.preventDefault()
    event.stopPropagation();
  });

  $('.js-sub-item').on('mouseover', function(event) {
    event.preventDefault()
    event.stopPropagation();

    const target = $(this).attr("class").split(/\s+/).find(c => c.includes('target-'));
    const $items = $('.js-sub-menu-item')

    if(!target) return

    const $subMenuPanel = $('.js-sub-nav')
    const subMenuId = target.split('-')[1]

    if($subMenuPanel.hasClass("is-shown")) {
      // toggle visibility
      if(categoryInSubmenu !== subMenuId) {
        $subMenuPanel.removeClass('is-shown')
        $(this).removeClass('is-active')
      }
    }
    if(categoryInSubmenu !== subMenuId) {
      $(this).siblings().removeClass('is-active')
      $(this).addClass('is-active')
      categoryInSubmenu = subMenuId
      $items.hide()
      $items.filter(`[data-category="${subMenuId}"]`).show()
      $subMenuPanel.addClass('is-shown')
    }
  })

  /* personalization buttons */
  $('#personalization-button-yes').on('click', function(event) {
    $('#personalization-button-no').removeClass("active");
    $(this).addClass("active");
    $($('button.single_add_to_cart_button.button')[0]).attr( "style", "display: none !important;" );
    $($('a#fpd-start-customizing-button')[0]).attr( "style", "display: block !important;" );
  })
  $('#personalization-button-no').on('click', function(event) {
    $('#personalization-button-yes').removeClass("active");
    $(this).addClass("active");
    $($('button.single_add_to_cart_button.button')[0]).attr( "style", "display: block !important;" );
    $($('a#fpd-start-customizing-button')[0]).attr( "style", "display: none !important;" );
  })
});

//Disable variations click except in the product page
window.addEventListener("DOMContentLoaded", function() {
  jQuery("body:not(.single-product) ul.variable-items-wrapper.wvs-catalog-variable-wrapper > li:not(.disabled):not(.woo-variation-swatches-variable-item-more)").each(function(a, i) {
    jQuery(this).off("click");
    jQuery(this).on("click", function(e) {
      jQuery(this).off("click");
    }, function() {
      jQuery(this).off("click");
    });
  });
  jQuery("body.single-product section.related-products ul.variable-items-wrapper.wvs-catalog-variable-wrapper > li:not(.disabled):not(.woo-variation-swatches-variable-item-more)").each(function(a, i) {
    jQuery(this).off("click");
    jQuery(this).on("click", function(e) {
      jQuery(this).off("click");
    }, function() {
      jQuery(this).off("click");
    });
  });
}, false);